import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import Quotationslider from "./quotationslider";
import "./homequotation.css";
import { GoArrowRight } from "react-icons/go";
const Homequotation = () => {
  // Initialize the selectedOption state using useState
  const [selectedOption, setSelectedOption] = useState("");
 
    const form = useRef();
    const [status, setStatus] = useState('');
  
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm(
        'service_k9vz6ab',      // Replace with your EmailJS Service ID
        'template_y0ldz2p',     // Replace with your Template ID
        form.current,
        'nVxbd2XcWHQ9AG6fm'       // Replace with your Public Key
      ).then(
        () => {
          setStatus('✅ Quotation request sent successfully!');
          form.current.reset();
          setSelectedOption('');
        },
        (error) => {
          setStatus('❌ Failed to send. Try again.');
          console.error(error);
        }
      );
    };
  

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value); // Update the state when option changes
  };
  return (
    <div className="homequtation">
      <div className="homequationslider">
        <div className="slide">
          {" "}
          <Quotationslider />
        </div>
      </div>
      <div className="homequotationcontent">
        {status && <p style={{ textAlign: "center", marginTop: "1rem" }}>{status}</p>}
        <p>Let’s Build Your Dream Space</p>
        <h2 className="header2">
        Get your Personalized <span>Quotation</span>
        </h2>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            placeholder="Enter Your Name"
            name="user_name"
            required
          />

<input
            type="number"
            placeholder="Enter your WhatsApp number"
            name="user_whatsapp"
           required
          />

<input
            type="email"
            placeholder="Enter your email ID"
            name="user_email"
            
          />

          <input
            type="text"
            placeholder="Enter your city or town"
            name="user_city"
           
          />


          <p className="requsting">
            <select
              id="options"
              value={selectedOption}
              name="user_service"
              onChange={handleSelectChange}
              required
            >
              <option  value="" disabled selected>Service Required</option>
              <option value="Home Interiors">Home Interiors</option>
              <option value="Modular Kitchen">Modular Kitchen</option>
              <option value="Office/Commercial Interiors">Office/Commercial Interiors</option>
              <option value="Custom Interior Units">Custom Interior Units (e.g., study tables, storage units, TV units)</option>
              <option value="Custom Packages">Custom Packages (e.g., 2BHK, 3BHK)</option>
            </select>
          </p>

          <button className="submit btn1">
            GET QUOTATION <span>{<GoArrowRight />}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Homequotation;